<template>
	<div class="page-container">
		<van-nav-bar title="我的兑换" left-arrow fixed @click-left="goableBack()" :z-index="10"></van-nav-bar>
		<div class="page">
			
			<van-tabs @rendered="rendered" v-model="active" animated sticky offset-top="45">

				<van-tab v-for="(tn,ti) of status" :name="`tab-${ti}`" :title="tn.text" :key="`tab-${ti}`">
					<ListTab :ref="`tab-${ti}`" :status="tn.value" :key="`list-tab-${ti}`"></ListTab>
				</van-tab>
				
			</van-tabs>
			
		</div>
	</div>
</template>

<script>
import { Tab, Tabs } from 'vant';
import ListTab from './list-tab.vue';
export default {
	name: 'list',
	data: () => ({
		active: "tab-0",
		list: {},
		/*list: {
			loading: false,
			finished: false,
			data: []
		},*/
		// 源码
		status: [
			{ text: '全部', value: '' },
			{ text: '待发货', value: 10 },
			{ text: '待收货', value: 11 },
			{ text: '已完成', value: 12 }
			// { text: '已取消', value: 20 },
			// { text: '退货申请中', value: 30 },
			// { text: '已退货', value: 31 }
		],
		form: {
			fields: {
				status: '',
				time: 'all',
				pageSize: 10,
				pageNo: 1
			}
		}
	}),
	beforeMount() {
		for (let [i,n] of this.status.entries()) {
			this.list[`tab-${i}`] = {
				loading:false,
				finished:false,
				data:[],
				form:{
					status: n.value,
					time: 'all',
					pageSize: 10,
					pageNo: 1
				}
			}
		}
	},
	computed: {},
	methods: {
		rendered(name) {
			this.$refs[name][0].load()
			console.log(name)
		},
	},
	components: {
		[Tab.name]: Tab,
		[Tabs .name]: Tabs,
		ListTab
	}
};
</script>

<style lang="less" scoped>
.page-container {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	margin: 0;
	box-sizing: border-box;
}

.right-icon {
	margin-right: 10px;
}
.row-title {
	font-size: 14px;
	text-overflow: -o-ellipsis-lastline;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}
.row-time {
	font-size: 12px;
	margin-top: -10px;
	margin-bottom: 5px;
	color: #999999;
}
.color-gray-dark {
	text-overflow: -o-ellipsis-lastline;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}
/*.van-tabs {
	::v-deep .van-sticky--fixed {
		top:45px;
	}
}*/
</style>
